var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "config-group-outline px-prj2 py-prj px-3@large border mt-prj3",
    },
    [
      _c("div", { staticClass: "row my-children-2" }, [
        _c("div", { staticClass: "small-12 column" }, [
          _c("h2", { staticClass: "h3 mt-0 mb-0" }, [
            _vm._v(_vm._s(_vm.group.title)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }